import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
export const useRetryAdHocPayment = (param)=>{
    let { errorTestId } = param;
    const { api } = useStoreActions();
    const { t } = useLocaleKeys();
    const { mutate, isPending } = useMutationState({
        mutationFn: (param)=>{
            let { invoiceId, fundingSourceId } = param;
            return api.invoice.retryAdHocPayment({
                invoiceId,
                fundingSourceId
            });
        },
        toasts: {
            errorMessage: t.invoice.adHocApproval.approveCta.approveError(),
            errorTestId
        }
    });
    return {
        retryAdHocPayment: mutate,
        isPending
    };
};
